import React from "react";
import "./Brands.css";
import logo1 from "../assets/bl1.png";
// import logo2 from "../assets/bl2.png";
import logo3 from "../assets/bl3.png";
import logo4 from "../assets/bl4.png";
import logo5 from "../assets/bl5.png";
import logo6 from "../assets/bl6.png";
// import logo7 from "../assets/bl7.png";

const Brands = () => {
  const logos = [logo1, logo3, logo4, logo5, logo6];

  return (
    <div className="brands-section">
      <div className="brands-row">
        {logos.map((logo, i) => (
          <img key={i} src={logo} alt="Brand Logo" className="brand-logo" />
        ))}
      </div>
    </div>
  );
};

export default Brands;
